<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import VDataTableCompanies from "@/components/VDataTable/VDataTableCompanies.vue";
import CompanyModal from "@/components/Companies/CompanyModal.vue";
import ComponentsKeys from "@/mixins/ComponentsKeys";
import VDialogConfirm from "@/components/commonComponents/VDialogConfirm.vue";

export default {
    name: "CompaniesModal",
    components: {
        VDialogConfirm,
        CompanyModal,
        VDataTableCompanies,
        AjaxLoad,
    },
    mixins: [
        ComponentsKeys,
    ],
    data() {
        return {
            isShow: false,
            result: false,
            componentsKeys: {
                companyModal: this.getRandomKey('companyModal'),
            },
            notifyOptions: {
                title: 'Компании',
            },
        };
    },
    watch: {
        isShow(v) {
            if (!v) {
                this.resolve(this.result);
                this.result = false;
            }
        },
    },
    methods: {
        show() {
            this.isShow = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        doShowModal(id) {
            this.$refs.companyModal.show(id)
                .then(response => {
                    if (response !== false) {
                        this.$refs.ajax.load();
                        this.result = true;
                    }
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.updateComponentKey('companyModal');
                });
        },
        onDblClickRow(e, {item}) {
            //this.result = item;
            this.$emit('dblclick:row', item.id);
            this.close();
        },
        onClickEdit(item) {
            this.doShowModal(item.id);
        },
        onClickAdd() {
            this.doShowModal(0);
        },
        onClickDelete(item) {
            this.$refs.confirmDelete.show(item)
                .then(response => {
                    if (response !== false) {
                        this.$refs.ajax.load();
                        this.result = true;
                    }
                })
                .catch(this.notifyError);
        },
        onConfirmDelete(item) {
            return this.$api.delete(this.$apiUrl.getCompanyUrl({id_company: item.id}));
        },
        onClickCancel() {
            this.close();
        },
        close() {
            this.isShow = false;
        },
    },
}
</script>

<template>
    <v-dialog
        v-if="isShow"
        v-model="isShow"
        max-width="600px"
        scrollable
    >
        <ajax-load
            ref="ajax"
            :url="$apiUrl.getCompaniesUrl()"
            :transform="response => response.data.data"
            v-slot="{data, resolved}"
        >
            <v-card>
                <v-card-title>Компании</v-card-title>
                <v-card-text class="pa-0">
                    <v-data-table-companies
                        :items="data"
                        :loading="!resolved"
                        :footer-props="{itemsPerPageOptions:[]}"
                        @dblclick:row="onDblClickRow"
                        @click:add="onClickAdd"
                        @click:edit="onClickEdit"
                        @click:delete="onClickDelete"
                    ></v-data-table-companies>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="onClickCancel">
                        Отмена
                    </v-btn>
                </v-card-actions>
            </v-card>
        </ajax-load>

        <company-modal
            ref="companyModal"
            :key="componentsKeys.companyModal"
        ></company-modal>

        <v-dialog-confirm
            ref="confirmDelete"
            type="delete"
            @confirm="onConfirmDelete"
            v-slot="{data}"
        >
            Удалить компанию {{data.name}}?
        </v-dialog-confirm>

    </v-dialog>
</template>

<style scoped lang="scss">

</style>
